import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer-wrapper">
      <p>&copy; 2024 Proseetings Skins. All rights reserved.</p>
    </footer>
  );
}

export default Footer;